import { Link } from 'react-router-dom';
import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function CTASection() {
  const { ref, isVisible, style } = useScrollReveal({ threshold: 0.1, distance: 36, duration: 900 });

  return (
    <section ref={ref} className="relative w-full bg-brand-black overflow-hidden py-20 md:py-28">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=elegant-bespoke-mens-suit-fabric-detail-dark-navy-wool-texture-close-up-silk-lining-buttons-minimal-soft-lighting-editorial-fashion-photography-luxury-tailoring&width=1400&height=800&seq=131&orientation=landscape"
          alt="Detalle sastrería alta costura"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-black/60" />
      </div>

      <div className="relative z-10 px-6 lg:px-[7%] flex flex-col items-center text-center" style={style}>
        <span className="font-sans text-white/60 text-[11px] tracking-[0.2em] uppercase font-medium">
          Reserva tu Consulta
        </span>
        <h2 className="font-serif text-white text-[clamp(2rem,4vw,3.2rem)] font-semibold leading-[1.15] mt-4 max-w-2xl">
          Tu traje a medida
          <span className="italic text-white/70"> empieza aquí</span>
        </h2>
        <p className="font-sans text-white/70 text-[15px] leading-[1.8] mt-5 max-w-xl">
          Agenda una consulta privada de 60 minutos en nuestro atelier del Eixample.
          Sin compromiso, solo sastrería artesanal de excelencia.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4">
          <Link
            to="/contacto"
            className="inline-flex items-center justify-center bg-white text-brand-black font-sans text-sm tracking-widest uppercase px-10 py-4 rounded-full hover:bg-white/90 hover:scale-105 transition-all duration-300 whitespace-nowrap"
          >
            Reservar Cita Privada
          </Link>
          <Link
            to="/alta-costura"
            className="inline-flex items-center justify-center border border-white/40 text-white font-sans text-sm tracking-widest uppercase px-10 py-4 rounded-full hover:bg-white/10 hover:scale-105 transition-all duration-300 whitespace-nowrap"
          >
            Conocer Alta Costura
          </Link>
        </div>
      </div>
    </section>
  );
}